import { render } from "./IconContentCopy.vue?vue&type=template&id=0ff0b824"
import script from "./IconContentCopy.vue?vue&type=script&lang=js"
export * from "./IconContentCopy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__